import { defineProductDimensions, frPrelPricingVersionDimension, frPrelSelectedDimension } from '@orus.eu/dimensions'

import { frPrelProductVersionDimension } from './fr-prel-dimensions.ts'
import { frPrelQuoteDimension } from './fr-prel-quote-dimension.ts'

export * from './fr-prel-activity-dimensions.ts'
export * from './fr-prel-dimensions.ts'
export * from './fr-prel-kanonik-dimensions.ts'
export * from './fr-prel-policy-item-dimension.ts'
export * from './fr-prel-quote-dimension.ts'
export * from './fr-prel-subscription-ui.ts'
export * from './fr-prel-ui-elements.ts'

export const frPrelDimensionsModule = defineProductDimensions({
  product: 'fr-prel',
  family: null,
  selectionDimension: frPrelSelectedDimension,
  productVersionDimension: frPrelProductVersionDimension,
  pricingVersionDimension: frPrelPricingVersionDimension,
  quoteV3Dimension: frPrelQuoteDimension,
})
